// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useData } from "../context/DataContext";
// import { useAuth } from "../context/AuthContext";
// import { ordersAPI } from "../api";

// export default function MyOrdersScreen() {
//     const { myOrders, refreshMyOrders } = useData();
//     const { user } = useAuth();
//     const navigate = useNavigate();
//     const [refreshing, setRefreshing] = useState(false);

//     // Загружаем мои заказы при монтировании
//     useEffect(() => {
//         refreshMyOrders();
//     }, [refreshMyOrders]);

//     // Сброс флага обновления при изменении данных
//     useEffect(() => {
//         if (refreshing) setRefreshing(false);
//     }, [myOrders]);

//     const onRefresh = () => {
//         if (refreshing) return;
//         setRefreshing(true);
//         refreshMyOrders();
//     };

//     const handleCallClient = async (phone, orderId) => {
//         if (!phone || phone === "—") {
//             alert("Номер телефона клиента отсутствует");
//             return;
//         }
//         if (user?.uid_master) {
//             ordersAPI.callClient(orderId, user.uid_master).catch(console.log);
//         }
//         const cleanedPhone = phone.replace(/[^\d+]/g, "");
//         window.location.href = `tel:${cleanedPhone}`;
//     };

//     const handleReport = (order) => {
//         navigate("/report", { state: { order } });
//     };

//     return (
//         <div className="px-4 pt-4">
//             <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-2xl font-bold text-gray-800">Мои заказы</h2>
//                 <button onClick={onRefresh} className="bg-blue-500 text-white py-1 px-3 rounded-full text-sm">
//                     {refreshing ? "Обновление..." : "Обновить"}
//                 </button>
//             </div>

//             {myOrders.length === 0 ? (
//                 <div className="text-center text-gray-500 py-10">Нет взятых заказов</div>
//             ) : (
//                 myOrders.map((item) => (
//                     <div key={item.id} className="bg-white p-4 mb-3 rounded-xl border border-gray-100 shadow-sm">
//                         <div className="text-2xl font-bold text-gray-800 mb-1">№ {item.orderNumber}</div>
//                         <div className="text-gray-700 text-base mt-2">{item.city || "—"}</div>
//                         <div className="text-gray-700 text-base">
//                             {item.title} {item.brand}
//                         </div>
//                         <div className="text-gray-700 text-base">Возраст (лет): {item.age || "—"}</div>
//                         <div className="text-gray-700 text-base">Описание: {item.description || "—"}</div>
//                         <div className="text-gray-700 text-base">Озвучены цены: {item.priceText || "—"}</div>
//                         <div className="text-gray-700 text-base">Комиссионные: {item.commission || "—"}</div>

//                         <div className="mt-2">
//                             <div className="text-gray-700 text-base">Представиться: {item.partner}</div>
//                             <div className="text-gray-700 text-base">
//                                 Быть: {item.appointmentDate || "не указано"} время: {item.appointmentTime || "не указано"}
//                             </div>
//                             <div className="text-gray-700 text-base">Клиент: {item.clientName || "Не указан"}</div>
//                             <div className="text-gray-700 text-base">Телефон клиента: {item.clientPhone || "—"}</div>
//                             <div className="text-gray-700 text-base">Адрес: {item.clientAddress || "—"}</div>
//                             <div className="text-gray-700 text-base">Дата заявки: {item.requestDate || "—"}</div>
//                             <div className="text-gray-700 text-base">Доп. инфо: {item.additionalInfo || "—"}</div>
//                             <div className="text-gray-700 text-base mt-2">Логист заказа: {item.logist || "Не назначен"}</div>
//                         </div>

//                         <button
//                             onClick={() => handleCallClient(item.clientPhone, item.orderNumber)}
//                             className="w-full bg-blue-500 py-3 rounded-full mb-2 mt-4 text-white font-medium">
//                             Позвонить клиенту
//                         </button>

//                         <button onClick={() => handleReport(item)} className="w-full bg-green-500 py-3 rounded-full text-white font-medium">
//                             Отчитаться
//                         </button>
//                     </div>
//                 ))
//             )}
//         </div>
//     );
// }

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useData } from "../context/DataContext";
// import { useAuth } from "../context/AuthContext";
// import { ordersAPI } from "../api";

// // Модальное окно "Договорились с клиентом"
// const AgreeModal = ({ visible, onClose, onSubmit, loading }) => {
//     const [comment, setComment] = useState("");

//     if (!visible) return null;

//     const handleSubmit = () => {
//         onSubmit(comment);
//         setComment("");
//     };

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
//             <div className="bg-white rounded-xl p-5 w-11/12 max-w-sm" onClick={(e) => e.stopPropagation()}>
//                 <h3 className="text-lg font-bold mb-3">Договорённость с клиентом</h3>
//                 <textarea
//                     className="w-full border border-gray-300 rounded-lg p-3 mb-4 min-h-[100px]"
//                     placeholder="О чем договорились?"
//                     value={comment}
//                     onChange={(e) => setComment(e.target.value)}
//                 />
//                 <div className="flex space-x-2">
//                     <button onClick={onClose} className="flex-1 bg-gray-200 py-2 rounded-lg font-medium">
//                         Отмена
//                     </button>
//                     <button onClick={handleSubmit} disabled={loading} className="flex-1 bg-green-500 text-white py-2 rounded-lg font-medium disabled:opacity-50">
//                         {loading ? "Отправка..." : "Отправить"}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default function MyOrdersScreen() {
//     const { myOrders, refreshMyOrders } = useData();
//     const { user } = useAuth();
//     const navigate = useNavigate();
//     const [refreshing, setRefreshing] = useState(false);

//     // Храним номера заказов, по которым был звонок
//     const [calledOrderNumbers, setCalledOrderNumbers] = useState([]);
//     const [modalVisible, setModalVisible] = useState(false);
//     const [currentOrder, setCurrentOrder] = useState(null);
//     const [agreeLoading, setAgreeLoading] = useState(false);

//     useEffect(() => {
//         refreshMyOrders();
//     }, [refreshMyOrders]);

//     useEffect(() => {
//         if (refreshing) setRefreshing(false);
//     }, [myOrders]);

//     const onRefresh = () => {
//         if (refreshing) return;
//         setRefreshing(true);
//         refreshMyOrders();
//     };

//     const handleCallClient = async (phone, orderNumber) => {
//         if (!phone || phone === "—") {
//             alert("Номер телефона клиента отсутствует");
//             return;
//         }
//         if (user?.uid_master) {
//             ordersAPI.callClient(orderNumber, user.uid_master).catch(console.log);
//         }
//         // Добавляем orderNumber в список позвонивших
//         console.log("Добавляем в calledOrderNumbers:", orderNumber);
//         setCalledOrderNumbers((prev) => {
//             if (prev.includes(orderNumber)) return prev;
//             return [...prev, orderNumber];
//         });

//         const cleanedPhone = phone.replace(/[^\d+]/g, "");
//         window.location.href = `tel:${cleanedPhone}`;
//     };

//     const handleAgree = (order) => {
//         setCurrentOrder(order);
//         setModalVisible(true);
//     };

//     const handleAgreeSubmit = async (comment) => {
//         if (!user?.uid_master || !currentOrder) return;
//         setAgreeLoading(true);
//         try {
//             await ordersAPI.agreeWithClient(currentOrder.orderNumber, user.uid_master, comment.trim());
//             alert("Спасибо! Информация сохранена.");
//             // Убираем номер из списка вызванных
//             setCalledOrderNumbers((prev) => prev.filter((num) => num !== currentOrder.orderNumber));
//             setModalVisible(false);
//             setCurrentOrder(null);
//             refreshMyOrders();
//         } catch (error) {
//             console.error(error);
//             alert("Не удалось отправить. Попробуйте снова.");
//         } finally {
//             setAgreeLoading(false);
//         }
//     };

//     const handleReport = (order) => {
//         navigate("/report", { state: { order } });
//     };

//     return (
//         <div className="px-4 pt-4">
//             <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-2xl font-bold text-gray-800">Мои заказы</h2>
//                 <button onClick={onRefresh} className="bg-blue-500 text-white py-1 px-3 rounded-full text-sm">
//                     {refreshing ? "Обновление..." : "Обновить"}
//                 </button>
//             </div>

//             {myOrders.length === 0 ? (
//                 <div className="text-center text-gray-500 py-10">Нет взятых заказов</div>
//             ) : (
//                 myOrders.map((item) => (
//                     <div key={item.id} className="bg-white p-4 mb-3 rounded-xl border border-gray-100 shadow-sm">
//                         <div className="text-2xl font-bold text-gray-800 mb-1">№ {item.orderNumber}</div>
//                         <div className="text-gray-700 text-base mt-2">{item.city || "—"}</div>
//                         <div className="text-gray-700 text-base">
//                             {item.title} {item.brand}
//                         </div>
//                         <div className="text-gray-700 text-base">Возраст (лет): {item.age || "—"}</div>
//                         <div className="text-gray-700 text-base">Описание: {item.description || "—"}</div>
//                         <div className="text-gray-700 text-base">Озвучены цены: {item.priceText || "—"}</div>
//                         <div className="text-gray-700 text-base">Комиссионные: {item.commission || "—"}</div>

//                         <div className="mt-2">
//                             <div className="text-gray-700 text-base">Представиться: {item.partner}</div>
//                             <div className="text-gray-700 text-base">
//                                 Быть: {item.appointmentDate || "не указано"} время: {item.appointmentTime || "не указано"}
//                             </div>
//                             <div className="text-gray-700 text-base">Клиент: {item.clientName || "Не указан"}</div>
//                             <div className="text-gray-700 text-base">Телефон клиента: {item.clientPhone || "—"}</div>
//                             <div className="text-gray-700 text-base">Адрес: {item.clientAddress || "—"}</div>
//                             <div className="text-gray-700 text-base">Дата заявки: {item.requestDate || "—"}</div>
//                             <div className="text-gray-700 text-base">Доп. инфо: {item.additionalInfo || "—"}</div>
//                             <div className="text-gray-700 text-base mt-2">Логист заказа: {item.logist || "Не назначен"}</div>
//                         </div>

//                         <button
//                             onClick={() => handleCallClient(item.clientPhone, item.orderNumber)}
//                             className="w-full bg-blue-500 py-3 rounded-full mb-2 mt-4 text-white font-medium">
//                             Позвонить клиенту
//                         </button>

//                         {/* Кнопка "Договарились" – показывается, если номер заказа есть в списке вызванных */}
//                         {calledOrderNumbers.includes(item.orderNumber) && (
//                             <button onClick={() => handleAgree(item)} className="w-full bg-yellow-500 py-3 rounded-full mb-2 text-white font-medium">
//                                 Договарились с клиентом
//                             </button>
//                         )}

//                         <button onClick={() => handleReport(item)} className="w-full bg-green-500 py-3 rounded-full text-white font-medium">
//                             Отчитаться
//                         </button>
//                     </div>
//                 ))
//             )}

//             <AgreeModal visible={modalVisible} onClose={() => setModalVisible(false)} onSubmit={handleAgreeSubmit} loading={agreeLoading} />
//         </div>
//     );
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useData } from "../context/DataContext";
import { useAuth } from "../context/AuthContext";
import { ordersAPI } from "../api";

// Модальное окно "Договорились с клиентом"
const AgreeModal = ({ visible, onClose, onSubmit, loading }) => {
    const [comment, setComment] = useState("");

    if (!visible) return null;

    const handleSubmit = () => {
        onSubmit(comment);
        setComment("");
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
            <div className="bg-white rounded-xl p-5 w-11/12 max-w-sm" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-lg font-bold mb-3">Договорённость с клиентом</h3>
                <textarea
                    className="w-full border border-gray-300 rounded-lg p-3 mb-4 min-h-[100px]"
                    placeholder="О чем договорились?"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
                <div className="flex space-x-2">
                    <button onClick={onClose} className="flex-1 bg-gray-200 py-2 rounded-lg font-medium">
                        Отмена
                    </button>
                    <button onClick={handleSubmit} disabled={loading} className="flex-1 bg-green-500 text-white py-2 rounded-lg font-medium disabled:opacity-50">
                        {loading ? "Отправка..." : "Отправить"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default function MyOrdersScreen() {
    const { myOrders, refreshMyOrders } = useData();
    const { user } = useAuth();
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(false);

    // Храним номера заказов, по которым был звонок
    const [calledOrderNumbers, setCalledOrderNumbers] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [agreeLoading, setAgreeLoading] = useState(false);

    useEffect(() => {
        refreshMyOrders();
    }, [refreshMyOrders]);

    useEffect(() => {
        if (refreshing) setRefreshing(false);
    }, [myOrders]);

    const onRefresh = () => {
        if (refreshing) return;
        setRefreshing(true);
        refreshMyOrders();
    };

    const handleCallClient = async (phone, orderNumber) => {
        if (!phone || phone === "—") {
            alert("Номер телефона клиента отсутствует");
            return;
        }
        if (user?.uid_master) {
            ordersAPI.callClient(orderNumber, user.uid_master).catch(console.log);
        }
        // Добавляем orderNumber в список позвонивших
        console.log("Добавляем в calledOrderNumbers:", orderNumber);
        setCalledOrderNumbers((prev) => {
            if (prev.includes(orderNumber)) return prev;
            return [...prev, orderNumber];
        });

        const cleanedPhone = phone.replace(/[^\d+]/g, "");
        window.location.href = `tel:${cleanedPhone}`;
    };

    const handleAgree = (order) => {
        setCurrentOrder(order);
        setModalVisible(true);
    };

    const handleAgreeSubmit = async (comment) => {
        if (!user?.uid_master || !currentOrder) return;
        setAgreeLoading(true);
        try {
            await ordersAPI.agreeWithClient(currentOrder.orderNumber, user.uid_master, comment.trim());
            alert("Спасибо! Информация сохранена.");
            // Убираем номер из списка вызванных
            setCalledOrderNumbers((prev) => prev.filter((num) => num !== currentOrder.orderNumber));
            setModalVisible(false);
            setCurrentOrder(null);
            refreshMyOrders();
        } catch (error) {
            console.error(error);
            alert("Не удалось отправить. Попробуйте снова.");
        } finally {
            setAgreeLoading(false);
        }
    };

    const handleReport = (order) => {
        navigate("/report", { state: { order } });
    };

    return (
        // 👇 Основное изменение: динамический отступ вместо фиксированного pt-4
        <div className="px-4" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 1rem)" }}>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold text-gray-800">Мои заказы</h2>
                <button onClick={onRefresh} className="bg-blue-500 text-white py-1 px-3 rounded-full text-sm">
                    {refreshing ? "Обновление..." : "Обновить"}
                </button>
            </div>

            {myOrders.length === 0 ? (
                <div className="text-center text-gray-500 py-10">Нет взятых заказов</div>
            ) : (
                myOrders.map((item) => (
                    <div key={item.id} className="bg-white p-4 mb-3 rounded-xl border border-gray-100 shadow-sm">
                        <div className="text-2xl font-bold text-gray-800 mb-1">№ {item.orderNumber}</div>
                        <div className="text-gray-700 text-base mt-2">{item.city || "—"}</div>
                        <div className="text-gray-700 text-base">
                            {item.title} {item.brand}
                        </div>
                        <div className="text-gray-700 text-base">Возраст (лет): {item.age || "—"}</div>
                        <div className="text-gray-700 text-base">Описание: {item.description || "—"}</div>
                        <div className="text-gray-700 text-base">Озвучены цены: {item.priceText || "—"}</div>
                        <div className="text-gray-700 text-base">Комиссионные: {item.commission || "—"}</div>

                        <div className="mt-2">
                            <div className="text-gray-700 text-base">Представиться: {item.partner}</div>
                            <div className="text-gray-700 text-base">
                                Быть: {item.appointmentDate || "не указано"} время: {item.appointmentTime || "не указано"}
                            </div>
                            <div className="text-gray-700 text-base">Клиент: {item.clientName || "Не указан"}</div>
                            <div className="text-gray-700 text-base">Телефон клиента: {item.clientPhone || "—"}</div>
                            <div className="text-gray-700 text-base">Адрес: {item.clientAddress || "—"}</div>
                            <div className="text-gray-700 text-base">Дата заявки: {item.requestDate || "—"}</div>
                            <div className="text-gray-700 text-base">Доп. инфо: {item.additionalInfo || "—"}</div>
                            <div className="text-gray-700 text-base mt-2">Логист заказа: {item.logist || "Не назначен"}</div>
                        </div>

                        <button
                            onClick={() => handleCallClient(item.clientPhone, item.orderNumber)}
                            className="w-full bg-blue-500 py-3 rounded-full mb-2 mt-4 text-white font-medium">
                            Позвонить клиенту
                        </button>

                        {/* Кнопка "Договарились" – показывается, если номер заказа есть в списке вызванных */}
                        {calledOrderNumbers.includes(item.orderNumber) && (
                            <button onClick={() => handleAgree(item)} className="w-full bg-yellow-500 py-3 rounded-full mb-2 text-white font-medium">
                                Договарились с клиентом
                            </button>
                        )}

                        <button onClick={() => handleReport(item)} className="w-full bg-green-500 py-3 rounded-full text-white font-medium">
                            Отчитаться
                        </button>
                    </div>
                ))
            )}

            <AgreeModal visible={modalVisible} onClose={() => setModalVisible(false)} onSubmit={handleAgreeSubmit} loading={agreeLoading} />
        </div>
    );
}
